// Omnix/client/ui/LinkTicketModal.js
import { ComponentBase } from "../core/ComponentBase.js";

export class LinkTicketModal extends ComponentBase {
    constructor(config) {
        super(config);
        this.modalInstance = null;
        this.searchTerm = '';
        this.searchResults = [];
        this.conversation = null;
        this.debouncedSearch = this.debounce(this.searchTickets, 300);
    }

    async initialize() {
        this.container = document.createElement('div');
        this.container.className = 'modal fade';
        this.container.id = `${this.config.instanceId}-modal`;
        this.container.innerHTML = `
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">${this.t('Link Existing Ticket')}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <input type="search" class="form-control" placeholder="${this.t('Search by Ticket # or Subject...')}">
                        <div class="list-group mt-3" id="ticket-search-results"></div>
                    </div>
                </div>
            </div>
        `;
        this.modalInstance = new bootstrap.Modal(this.container);
        this.searchInput = this.container.querySelector('input');
        this.resultsContainer = this.container.querySelector('#ticket-search-results');
        this.searchInput.addEventListener('input', (e) => this.debouncedSearch(e.target.value));
    }

    show(conversation) {
        this.conversation = conversation;
        this.searchTerm = '';
        this.searchResults = [];
        this.searchInput.value = '';
        this.renderResults();
        this.modalInstance.show();
    }

    async searchTickets(term) {
        this.searchTerm = term.trim();
        if (this.searchTerm.length < 2) {
            this.searchResults = [];
            this.renderResults();
            return;
        }
        try {
            const orClauses = [
                { subject: { $regex: this.searchTerm, $options: 'i' } }
            ];

            const searchTermAsNumber = parseInt(this.searchTerm, 10);
            if (!isNaN(searchTermAsNumber)) {
                orClauses.push({ ticketNumber: searchTermAsNumber });
            }

            const filter = {
                contactId: this.conversation.contactId, // This is the custom contactId
                status: { $ne: 'closed' },
                $or: orClauses // The $or key now correctly holds the array of conditions
            };

            const result = await this.appClient.rpcClient.call('TicketRpc.getData', { filter });
            this.searchResults = result.data || [];
            this.renderResults();
        } catch (error) {
            this.log.error("Failed to search tickets:", error);
        }
    }


    renderResults() {
        this.resultsContainer.innerHTML = '';
        if (this.searchResults.length === 0) {
            this.resultsContainer.innerHTML = `<p class="text-muted p-2">${this.t('No matching open tickets found for this contact.')}</p>`;
            return;
        }
        this.searchResults.forEach(ticket => {
            const item = document.createElement('a');
            item.href = '#';
            item.className = 'list-group-item list-group-item-action';
            item.innerHTML = `
                <strong>#${ticket.ticketNumber}</strong> - ${ticket.subject}
                <div class="small text-muted">${this.t('Status')}: ${this.t(ticket.status)}</div>
            `;
            item.addEventListener('click', (e) => {
                e.preventDefault();
                this.emit('ticketLinked', { ticketId: ticket._id });
                this.modalInstance.hide();
            });
            this.resultsContainer.appendChild(item);
        });
    }

    debounce(func, delay) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    }

    render() { return this.container; }
}
